import React, { useEffect } from 'react';
import { LogClick, useClickStreamContext } from '../../ClickStream';
import { usePopupContext } from '../AdvertisementPopupContext';
import { Title, Text, Content, Button } from './PopupStyled';
import { PopupProps } from '../PopupModel';
import useShowPopup from './useShowPopup';
import { PopupsApi } from 'api';
import ModalV2 from '../../ModalV2';
import { Link } from 'react-router-dom';

const Popup = (props: PopupProps & { subjectId: number }) => {
  const { isShown, hide } = useShowPopup(props.id);
  const context = useClickStreamContext();
  const { setShowed } = usePopupContext();
  const handleClose = () => {
    hide();
    context.logPageEvent?.({
      eventType: `click_close_${props.id}_popup`,
      eventInfo: `${props.id}: Клик закрытия попапа`,
      eventSource: 'municipality',
    });
    setShowed(true);
  };

  useEffect(() => {
    if (isShown) {
      context.logPageEvent?.({
        eventType: `show_${props.id}_popup`,
        eventInfo: `${props.id}: Показан попапа`,
        eventSource: 'municipality',
      });
      PopupsApi.loggedShowPopup(+props.id, { subjectId: props.subjectId });
      return () => {
        setShowed(true);
      };
    }
  }, [isShown]);
  const buttonProps: any =
    props.link && !props.link.match(/^http/) ? { as: Link, to: props.link } : { href: props.link };
  if (!isShown) return <></>;
  return (
    <ModalV2 onClose={handleClose} withoutPadding disableCloseByClickByOverlay>
      <Content>
        <Title dangerouslySetInnerHTML={{ __html: props.title }}></Title>
        <Text dangerouslySetInnerHTML={{ __html: props.text }}></Text>
        <LogClick
          eventType={`click_link_from_${props.id}_popup`}
          eventInfo={`${props.id}: Переход на лендинг из попапа`}
        >
          <Button {...buttonProps} onClick={() => setShowed(true)}>
            {props.buttonTitle}
          </Button>
        </LogClick>
      </Content>
    </ModalV2>
  );
};

export default Popup;
